import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConstants } from "../app_setting/app-constants";
import { BaseResponse } from "../models/base-response";
import { environment } from "src/environments/environment";

export enum ContentTypeEnum {
  JSON,
  FORMDATA,
}

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class WrapperService {
  constructor(protected httpClient: HttpClient) {}

  get: Function = (url: string) => {
    this.buildHttpsHeaders();
    return this.httpClient.get<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      httpOptions
    );
  };

  getFile: Function = (url: string) => {
    this.buildHttpsHeaders();
    return this.httpClient.get(`${environment.apiBaseUrlGt}${url}`, {
      headers: httpOptions.headers,
      responseType: "blob",
    });
  };

  post: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  postMultipartFormData: Function = (url: string, param: any) => {
    const token = localStorage.getItem(AppConstants.RegisterTokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set("Authorization", "Bearer " + token);
      // .set(AppConstants.TimeZone, this.getTimeZone());

    return this.httpClient.post<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  putMultipartFormData: Function = (url: string, param: any) => {
    const token = localStorage.getItem(AppConstants.RegisterTokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set("Authorization", "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());

    return this.httpClient.put<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  put: Function = (url: string, param: any) => {
    this.buildHttpsHeaders();

    return this.httpClient.put<BaseResponse>(
      `${environment.apiBaseUrlGt}${url}`,
      param,
      httpOptions
    );
  };

  private getTimeZone: Function = () => {
    const timeZoneOffset = new Date().getTimezoneOffset();
    if (timeZoneOffset < 0) {
      return `UTC+0${timeZoneOffset / -60}:00`;
    } else {
      return `UTC-0${timeZoneOffset / 60}:00`;
    }
  };

  private buildHttpsHeaders() {
    const token = localStorage.getItem(AppConstants.RegisterTokenId);
    if (token === "" || token === undefined || token === null) {
      return;
    }

    httpOptions.headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", "Bearer " + token)
      .set(AppConstants.TimeZone, this.getTimeZone());
  }
}
